// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__6XzOs","spin":"Loader_spin__JY_VB"};